import Icon from "@ant-design/icons"
import { ReactComponent as BrazilFlag } from "./brazil.svg"

const BrazilFlagIcon = (props: any) => <Icon component={BrazilFlag} {...props} />

export default BrazilFlagIcon
